import { useState } from 'react';
import {
  getCoreRowModel,
  getSortedRowModel,
  type SortingState,
  useReactTable,
} from '@tanstack/react-table';

import { type DatasetsQueryResult, useFiles } from '@/api/generated';
import { DataTable } from '@/components/blocks/data-table/data-table';
import type { ExpandableRowProps } from '@/components/blocks/data-table/expandable-row';
import { Spinner } from '@/components/ui/spinner';
import { columns } from '@/routes/(app)/(datasets)/lib/dataset-expansion-columns';

type DatasetExpansionProps = ExpandableRowProps<
  DatasetsQueryResult['data'][number]
>;
const DatasetExpansion = ({ row }: DatasetExpansionProps) => {
  const [sorting, setSorting] = useState<SortingState>([]);
  const { data: files, isLoading } = useFiles(row.original.id);

  const table = useReactTable({
    data: files ?? [],
    columns,
    state: {
      sorting,
    },
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
  });
  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <DataTable
          table={table}
          isNested
        />
      )}
    </>
  );
};

export default DatasetExpansion;
